import React, { Component } from 'react';
import { connect } from 'react-redux';
import { debounce } from 'throttle-debounce';
import { dAPI } from 'appSrc/api';
import { Facebook } from 'appSrc/components/Facebook/Script';
import MetaData from 'appSrc/components/Shards/MetaData';
import DLUnloader from 'appSrc/components/Shards/Unloader';
import Theater from 'appSrc/components/Shards/Theater';
import ProRegistrationCompleteModal from 'appSrc/components/Pro/RegistrationCompleteModal';
import ShareGroupPopup from 'appSrc/components/Share/GroupPopup';
import organization from 'appSrc/data/organization';
import { push } from 'connected-react-router';
import { initialCheckTokens, updateScreenSize, getSelf, documentLoaded,
    updateVars, setTestGroup, updateDisplayState } from 'appSrc/redux/actions';


class Global extends Component {
    constructor( props ) {
        super( props );

        //init Facebook
        Facebook.init( {
            appId: process.env.FACEBOOK_APP_ID,
            debug: process.env.NODE_ENV != 'production',
        } );


        this.props.getInterestOptions()
        .then( ( interests ) => {
            interests.sort( ( a, b ) => {
                return a.interest.localeCompare( b.interest );
            } );
            this.props.updateVars( { interests } );
        } );

        this.props.getCategoryOptions()
        .then( ( categoryTree ) => {
            this.props.updateVars( { categoryTree } );
        } );

        if( this.props.checkLoggedInState() ) {
            this.props.getSelf();
        }

        //set the state to update when the window is set and resizes
        this.props.updateScreenSize( window.innerWidth );
        window.onload = () => {
            this.props.updateScreenSize( window.innerWidth );
            this.props.updateDisplayState( {
                width: window.innerWidth,
                scroll: window.scrollY,
            } );
            this.props.documentLoaded();
        };
        const resizeFunc = debounce( 100, () => {
            this.props.updateScreenSize( window.innerWidth );
            this.props.updateDisplayState( { width: window.innerWidth } );
        } );
        window.addEventListener( 'resize', () => {
            resizeFunc();
        } );
        window.addEventListener( 'scroll', () => {
            this.props.updateDisplayState( {
                scroll: window.scrollY,
            } );
        } );
    }
    componentDidUpdate( prevProps ) {
        //check if user is logged in
        if( prevProps.self.userid !== this.props.self.userid ) {
            if( this.props.self.userid ) {
                if( this.props.self.usertype === 'admin' ) {
                    window.localStorage.setItem( 'adminUser', true );
                }
            }
        }

        if( prevProps.location.pathname !== this.props.location.pathname ) {
            //scroll to window top when page changes
            !!window && window.scrollTo( 0, 0 );
        }
    }


    render() {
        return (
            <div>
                <DLUnloader />
                <MetaData data={ organization } />
                <ProRegistrationCompleteModal />
                <Theater />
                <ShareGroupPopup />
            </div>
        );
    }
}

const mapStateToProps = ( state ) => {
    return {
        loggedIn: state.auth.loggedIn,
        self: state.self.user,
        selfData: state.self,
        interestsSet: state.vars.interests,
        location: state.router.location,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        checkLoggedInState: () => {
            return dispatch( initialCheckTokens() );
        },
        updateScreenSize: ( width ) => {
            dispatch( updateScreenSize( width ) );
        },
        updateDisplayState: ( data ) => {
            dispatch( updateDisplayState( data ) );
        },
        setTestGroup: ( name, group ) => ( dispatch( setTestGroup( name, group ) ) ),
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
        getInterestOptions: () => {
            return dAPI.get( '/interests' );
        },
        documentLoaded: () => {
            return dispatch( documentLoaded() );
        },
        updateVars: ( data ) => {
            return dispatch( updateVars( data ) );
        },
        getCategoryOptions: () => {
            return dAPI.get( '/categories', {
                sort: 'id,child_categories.id',
            } )
            .catch( () => [] );
        },
        getSelf: () => {
            return dispatch( getSelf() );
        },
        getProfile: ( slug ) => {
            return dAPI.get( `/users/slug/${ slug }` );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Global );
